interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  href?: string;
  index?: string;
  inverse?: boolean;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  href,
  index,
  inverse = false,
}: SectionHeadingProps) {
  const kickerColor = inverse ? 'text-accent-400' : 'text-primary-700';
  const titleColor = inverse ? 'text-background-50' : 'text-foreground-950';
  const descColor = inverse ? 'text-background-200' : 'text-foreground-600';
  const ruleColor = inverse ? 'bg-accent-400' : 'bg-primary-500';
  const borderColor = inverse ? 'border-background-50/40' : 'border-foreground-950';

  return (
    <header className={`border-t-2 ${borderColor} pt-4`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <span className={`h-px w-8 ${ruleColor}`} />
          <span className={`font-label text-[11px] uppercase tracking-[0.32em] ${kickerColor}`}>
            {kicker}
          </span>
        </div>
        {index && <span className={`font-label text-[11px] tracking-[0.2em] ${descColor}`}>{index}</span>}
      </div>
      <h2 className={`mt-3 font-heading text-2xl font-bold leading-snug md:text-4xl ${titleColor}`}>
        {href ? (
          <a href={href} className="transition-colors hover:text-primary-500">
            {title}
          </a>
        ) : (
          title
        )}
      </h2>
      {desc && <p className={`mt-3 max-w-3xl text-sm leading-relaxed md:text-base ${descColor}`}>{desc}</p>}
    </header>
  );
}